import { useMutation } from '@tanstack/react-query';
import { httpService } from '@services/httpService';
import { ApiRoute } from '@routes/apiRoutes';
import { LoginResponseModel } from '@models/login/loginResponseModel';

export const useSessionLoginApi = () => {
  const login = async (sessionToken: string) => {
    return await httpService.post<LoginResponseModel>(
      ApiRoute.SessionLogin,
      sessionToken
    );
  };

  return useMutation({
    mutationFn: (sessionToken: string) => login(sessionToken),
  });
};
